import { ShoppingBag } from 'lucide-react';
import { useRef } from 'react';
import CardTitle from '@/domains/mobile-web/components/CardTitle/CardTitle';
import type { ProductSummary } from '@/domains/mobile-web/types/product.types';
import { formatPrice, priceView } from '@/domains/mobile-web/utils/price';

interface CardProductProps {
  product: ProductSummary;
  onBuy?: (product: ProductSummary) => void;
  /** `origin` is the cover (or the button) the fly-to-cart thumbnail takes off from */
  onAddCart?: (product: ProductSummary, origin: HTMLElement) => void;
  /** Click anywhere on the card except its buttons */
  onOpen?: (product: ProductSummary) => void;
}

const CardProduct = ({ product, onBuy, onAddCart, onOpen }: CardProductProps) => {
  const { hasDiscount, original, final } = priceView(product);
  const coverRef = useRef<HTMLImageElement>(null);

  return (
    <article className="relative w-full shadowCard p-3 flex flex-col gap-3  justify-between h-full">
      <figure className="aspect-[1/1.15] w-full overflow-hidden rounded-[12px]">
        {product.image_url && (
          <img
            ref={coverRef}
            src={product.image_url}
            alt={product.title}
            className="block h-full w-full object-cover"
          />
        )}
      </figure>

      <div className="flex flex-col gap-1">
        <p className=" text-text-grey  lg:text-[14px] md:text-[14px]">{product.author}</p>
        <h3 className="line-clamp-2  title3bold lg:text-[16px] md:text-[16px] text-black">
          <CardTitle product={product} onOpen={onOpen} />
        </h3>
      </div>
      <div className="h-px  w-full bg-blue-cs-200" />
      {hasDiscount && (
        <p className=" ml-2 text-text-danger-500 title2 line-through">RP{formatPrice(original)}</p>
      )}
      <p className=" text-black title2bold lg:text-[16px] md:text-[16px]">
        Rp {formatPrice(final)}
      </p>

      <div className="flex items-center gap-3 flex-wrap w-full">
        <button
          type="button"
          onClick={(event) => onAddCart?.(product, coverRef.current ?? event.currentTarget)}
          aria-label={`Tambah ${product.title} ke keranjang`}
          className="relative flex h-[51px] w-[51px] shrink-0 items-center justify-center rounded-[8px] border border-blue-cs-200 bg-white text-[#007AFF] transition hover:bg-[#F3F8FF]"
        >
          <ShoppingBag size={25} strokeWidth={1.8} />

          <span className="absolute -right-[7px] -top-2 flex h-5 w-5 items-center justify-center rounded-full bg-text-blue-100  text-white">
            +
          </span>
        </button>

        <button
          type="button"
          onClick={() => onBuy?.(product)}
          className="relative flex-1  body1medium btn-fill-blue"
        >
          Beli Sekarang
        </button>
      </div>
    </article>
  );
};

export default CardProduct;
